import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import { connect } from "react-redux";

import { setItem } from "../../actions";

import { usePrevious } from '../../hooks/usePrevious';
import makePath from '../../utils/makePath';
import { TextInput } from './TextInput';
import { RichTextEditor } from './RichTextEditor';

/**
 * @todo
 * Refactor to use useDispatch instead of connect
 */

export const TitleInput = connect(null, { setItem })(

  React.memo(({name,given:propsGiven,multiline,path,setItem,wysiwyg,...props}) => {
    const [title, setTitle] = useState('')
    const [displayTitle, setDisplayTitle] = useState('')
    const [given, setGiven] = useState('')
    const oldWysiwyg = usePrevious(wysiwyg);

    // Callback for TextInput or RichTextEditor to update this component
    // instead of directly updating the store. Need to perform modifications
    // first, then update store.
    const updateFromChild = update => {
      let { title: displayTitle } = update;

      // strips tags and non-alphanumeric characters, and replaces spaces with hyphens
      const id = displayTitle.toLowerCase().replace(/<[^>]*>/g, '').replace(/[ ]|&nbsp;/g, '-').replace(/[^-a-zA-Z0-9 ]/g, '');
      // strips tags
      const title = displayTitle.replace(/<[^>]*>/g, '')

      if (wysiwyg) {
        // strips paragraph tags
        displayTitle = displayTitle.replace(/<[^>]?p>/g, '');
      } else {
        displayTitle = title;
      }

      setTitle(title);
      setDisplayTitle(displayTitle)
      setAllTitleItems(title,id,displayTitle);
    }

    // Sets title, id, and displayTitle 
    const setAllTitleItems = (title,id,displayTitle) => {
      setItem(makePath(path,'title'),title);
      setItem(makePath(path,'id'),id);
      setItem(makePath(path,'displayTitle'),displayTitle);
    }

    // Strip RTE title if input type switches to plain
    useEffect(() => {
      if (wysiwyg === oldWysiwyg) {
        return;
      }
      if (!wysiwyg && displayTitle && displayTitle.search(/<[^>]*>/g) >= 0 ) {
        setDisplayTitle(title)
        setItem(makePath(path,'displayTitle'),title);
      } else {
        setGiven(title);
      }
    }, [displayTitle, wysiwyg, path, setItem, title, oldWysiwyg])

    // Set state from given value
    useEffect(() => {
      setTitle(propsGiven)
      setDisplayTitle(propsGiven)
      setGiven(propsGiven)
    }, [propsGiven])

    // Render
    if (wysiwyg) {
      return <RichTextEditor
        {...props}
        name="title"
        updateParent={updateFromChild}
        help={props.help}
        given={given}
        inlineToolbarControls={false}
        defaultValue={props.defaultText}
      />
    } else {
      return <TextInput 
        {...props}
        multiline={multiline}
        rows={3}
        name="title"
        updateParent={updateFromChild}
        help={props.help}
        given={title}
      />
    }

  })
)

TitleInput.propTypes = {
  wysiwyg: PropTypes.bool,
  updateParent: PropTypes.func
}